import {
  GET_RESERVATION_TYPE_REQUEST,
  LIST_RESERVATION_TYPES_REQUEST
} from './constants';

export const listReservationTypes = () => ({
  type: LIST_RESERVATION_TYPES_REQUEST
});

export const getReservationType = (slug) => ({
  type: GET_RESERVATION_TYPE_REQUEST,
  slug
});
